const rg = (value, optional) => {
  if (optional && (value === '' || !value)) {
    return true
  }
  if (value === '' || !value) return false
  if (!/(^[a-zA-Z0-9]{1,13}$)/.test(value)) return false
  return true
}

export { rg }
export default { rg }
